import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IBaseSearchRequest } from 'src/app/core/models/base';
import { IEmployeeRole, IEmployeeRoleRequest } from '../../employee/employee-roles';
import { EmployeeRoleService } from '../services/employee-role.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeRoleStoreService {

  constructor(private employeeRoleService: EmployeeRoleService) {
    this.listEmployeeRoles();
   }

  private _employeeRoles$ = new BehaviorSubject<IEmployeeRole[]>([]);
  public employeeRoles$ = this._employeeRoles$.asObservable();


  listEmployeeRoles(request: IBaseSearchRequest = {pageNumber: 0, pageSize:999999}){
    this.employeeRoleService.listEmployeeRoleRoles(request).subscribe(response => {
      this._employeeRoles$.next(response.data)
    })
  }

  addEmployeeRole(request: IEmployeeRoleRequest){
    this.employeeRoleService.addEmployeeRoleRole(request)
      .subscribe(response => {
        this.listEmployeeRoles();
      })
  }

  updateEmployeeRole(request: IEmployeeRole){
    this.employeeRoleService.updateEmployeeRoleRole(request)
      .subscribe(response => {
        this.listEmployeeRoles();
      })
  }

  deleteEmployeeRole(id:string){
    this.employeeRoleService.deleteEmployeeRoleRole(id)
      .subscribe(response => {
        this.listEmployeeRoles();
      })
  }

}
